/**
 * Foundations Column Mapping
 * Identity mapping: field name to itself
 */

export const FOUNDATIONS_REVERSE_MAPPING: { [fieldName: string]: string } = {
  // Excavate & Concrete
  'pileMat': 'pileMat',
  'pileMatRemoval': 'pileMatRemoval',
  'plotGarSetOut': 'plotGarSetOut',
  'pileSetOut': 'pileSetOut',
  'pileAttendance': 'pileAttendance',
  'excavateTrench': 'excavateTrench',
  'excavatePiled': 'excavatePiled',
  'excavateVibro': 'excavateVibro',
  'levelCompact': 'levelCompact',
  'stockpileArisings': 'stockpileArisings',
  'concreteBlinding': 'concreteBlinding',
  'formplasOrSimilar': 'formplasOrSimilar',
  'cropPiles': 'cropPiles',
  'fillSteelPiles': 'fillSteelPiles',
  'rebar': 'rebar',
  'stepsInFounds': 'stepsInFounds',
  'meshReinforcement': 'meshReinforcement',
  'gen1ConcreteToStrip': 'gen1ConcreteToStrip',
  'rc35ConcreteToPiled': 'rc35ConcreteToPiled',
  'rc35ConcreteToVibro': 'rc35ConcreteToVibro',
  'stripClaymaster': 'stripClaymaster',
  'piledClaymaster': 'piledClaymaster',

  // Substructure
  'trench4NBlock300mmWide': 'trench4NBlock300mmWide',
  'trench7NBlock300mmWide': 'trench7NBlock300mmWide',
  'trench4NBlock355mmWide': 'trench4NBlock355mmWide',
  'trench7NBlock355mmWide': 'trench7NBlock355mmWide',
  'dense4NBlockwork100mm': 'dense4NBlockwork100mm',
  'dense7NBlockwork100mm': 'dense7NBlockwork100mm',
  'dense10NBlockwork100mm': 'dense10NBlockwork100mm',
  'aerated4NBlockwork100mm': 'aerated4NBlockwork100mm',
  'aerated7NBlockwork100mm': 'aerated7NBlockwork100mm',
  'aerated4NBlockwork140mm': 'aerated4NBlockwork140mm',
  'aerated7NBlockwork140mm': 'aerated7NBlockwork140mm',
  'dense100mmCoursingBrick': 'dense100mmCoursingBrick',
  'aerated100mmCoursingBrick': 'aerated100mmCoursingBrick',
  'aerated140mmCoursingBrick': 'aerated140mmCoursingBrick',
  'layFacingBrickwork': 'layFacingBrickwork',
  'supplyFacingBrickwork': 'supplyFacingBrickwork',
  'beamInfill': 'beamInfill',
  'formCavity': 'formCavity',
  'cavityFill': 'cavityFill',
  'telescopicVents': 'telescopicVents',
  'telescopicVents140': 'telescopicVents140',
  'perimeterInsulation': 'perimeterInsulation',
  'perimeterInsulation30': 'perimeterInsulation30',
  'dpc100mm': 'dpc100mm',
  'backfillExcavations': 'backfillExcavations',
  'cavityInsulation': 'cavityInsulation',

  // Abnormals
  'additionalExcavation': 'additionalExcavation',
  'gen1AdditionalConcrete': 'gen1AdditionalConcrete',
  'additional300mmTrenchBlock': 'additional300mmTrenchBlock',
  'additional355mmTrenchBlock': 'additional355mmTrenchBlock',
  'additional100mmBlockwork': 'additional100mmBlockwork',
  'backfillExcavationsAsDug': 'backfillExcavationsAsDug',
  'depositOnSite': 'depositOnSite',
  'eoExposedBrickwork': 'eoExposedBrickwork',
  'eoTanking': 'eoTanking',
  'depositCFAArisings': 'depositCFAArisings',
  'pileCollar': 'pileCollar',
  'cordekCellcore155': 'cordekCellcore155',
  'cordekCellcore225': 'cordekCellcore225',

  // Floors
  'bbFloorHouse': 'bbFloorHouse',
  'bbFloorGarage': 'bbFloorGarage',
  'layOnlyFloors': 'layOnlyFloors',
  'insituFloorHouse': 'insituFloorHouse',
  'topHats': 'topHats',
  'eo2000gDPM': 'eo2000gDPM',
  'eoAmber1DPM': 'eoAmber1DPM',
  'eoAmber2DPM': 'eoAmber2DPM',
  'radonMembrane': 'radonMembrane',
  'gasMembrane': 'gasMembrane',
  'meshToFloor': 'meshToFloor',
  'topLayerMesh': 'topLayerMesh',
  'insituFloorGarage': 'insituFloorGarage',
  'meshToGarageFloor': 'meshToGarageFloor',
  'raft': 'raft',
};
